module.exports = [
  { // Gender
    question: {
      label: 'What is your gender, from birth?',
      prompt: 'gender'
    }, 
    input: 'radio',
    options: [
      { label: 'Male', value: 'male' },
      { label: 'Female', value: 'female' },
    ]
  },
  { // Age
    question: {
      label: 'How old are you?',
      prompt: 'age'
    }, 
    input: 'radio',
    options: [
      { label: '35 or younger', value: '35 or younger' },
      { label: '36-50', value: '36-50' },
      { label: '51-65', value: '51-65' },
      { label: '66-80', value: '66-80' },
      { label: '81 or older', value: '81 or older' }
    ]
  },
  { // Cause
    question: {
      label: 'Is this condition a result of:',
      prompt: 'cause'
    }, 
    input: 'radio',
    options: [
      { label: 'Accident or Sports Injury', value: 'sports_injury' },
      { label: 'A Chonic Injury', value: 'chronic_injury' },
      { label: 'An Acutely Developed Pain', value: 'acute_injury' },
      { label: 'Progressive Arthritis/Tendonitis', value: 'arthritis_tendonitis' },
      { label: 'Not Sure', value: 'unknown' },
    ]
  },
  { // Past Treatments
    question: {
      label: `Mark any treatments you've had`,
      prompt: 'past_treatments'
    }, 
    input: 'checkbox',
    options: [
      { label: 'Injection', value: 'injection' },
      { label: 'Physical Therapy', value: 'pt' },
      { label: 'Imaging (x-ray, MRI)', value: 'imaging' },
      { label: 'Surgery', value: 'surgery' },
      { label: 'None of the Above', value: 'none' },
    ]
  },
  { // Past Visits
    question: {
      label: `Have you had an evaluation by medical personnel?`,
      prompt: 'past_visits'
    }, 
    input: 'checkbox',
    options: [
      { label: 'Primary Care', value: 'primary' },
      { label: 'Orthopedic', value: 'orthropedic' },
      { label: 'Emergency Care', value: 'er' },
      { label: 'Chiropractor', value: 'chiropractor' },
      { label: 'None', value: 'none' },
    ]
  },
  { // Pain Description
    question: {
      label: 'Describe your pain',
      prompt: 'pain_description'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Chronic', value: 'chronic' },
      { label: 'Acute', value: 'acute' },
      { label: 'Intermittent', value: 'intermittent' }
    ]
  },
  { // Swelling
    question: {
      label: 'Describe your swelling',
      prompt: 'swelling'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Moderate', value: 'moderate' },
      { label: 'Severe', value: 'severe' },
    ]
  },
  { // Instability
    question: {
      label: 'Do you have any sense of instability?',
      prompt: 'instability'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Mild', value: 'mild' },
      { label: 'Moderate', value: 'moderate' },
      { label: 'Severe', value: 'severe' },
    ]
  },
  { // ROM
    question: {
      label: `Is your foot's range of motion:`,
      prompt: 'rom'
    }, 
    input: 'radio',
    options: [
      { label: 'Painful or Unable to Perform', value: 'painful_or_unable' },
      { label: 'Limited', value: 'limited' },
      { label: 'Normal', value: 'normal' },
    ]
  },
  { // Numbness
    question: {
      label: 'Do you have numbness on or around the foot?',
      prompt: 'numbness'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Occasional', value: 'occasional' },
      { label: 'Frequent', value: 'frequent' },
    ]
  },
  { // Grinding
    question: {
      label: 'Any sense of grinding inside the joint when rotating?',
      prompt: 'grinding'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'Intermittent', value: 'intermittent' },
      { label: 'No', value: 'no' },
    ]
  },
  // { // Pain
  //   question: {
  //     label: 'What level of pain are you feeling right now?',
  //     prompt: 'pain'
  //   },
  //   input: 'slider'
  // },
  
  
  { // Pain Location
    question: {
      label: 'Where is your pain located?',
      prompt: 'pain_location'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Toes', value: 'toes' },
      { label: 'Midfoot', value: 'midfoot' },
      { label: 'Bottom of Heel', value: 'bottom_of_heel' },
      { label: 'Back of Heel', value: 'back_of_heel' },
      { label: 'Ankle', value: 'ankle' },
    ]
  },
  { // Flex Big Toe
    question: {
      label: 'Can you flex your big toe?',
      prompt: 'big_toe_flexibility'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'Limited', value: 'limited' },
      { label: 'No', value: 'no' },
    ]
  }, 
  { // Flex SMALL Toe
    question: {
      label: 'Has flexibility in your lesser toes (2-5) decreased?',
      prompt: 'lesser_toe_flexibility'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Weightbearing issues
    question: {
      label: 'Do you have any issues bearing weight?',
      prompt: 'weightbearing'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'Limited by Pain', value: 'limited' },
      { label: 'No', value: 'no' },
    ]
  }, 
]